// Textos das plataformas na administração de usuários (02/11/2026), coletados por glob
// em core/i18n/messages.ts. A coluna da lista vem de um config declarativo, e por isso
// o cabeçalho entra também como `declarative.Plataformas`.
export default {
  pt: {
    'declarative.Plataformas': 'Plataformas',
    'usuarios.plataformas.superusuario': 'Superusuário',
    'usuarios.plataformas.portal': 'Portal do cliente',
    'usuarios.plataformas.cliente': 'Cliente',
    'usuarios.plataformas.nenhuma': 'Nenhuma',
    'usuarios.plataformas.titulo': 'Acesso às plataformas',
    'usuarios.plataformas.regraSuper': 'Superusuário entra nas duas plataformas, com todas as áreas.',
    'usuarios.plataformas.regraOperador': 'A plataforma vem das áreas: entra onde o cargo ou as áreas próprias dão ao menos uma área.',
    'usuarios.plataformas.regraCliente': 'Usuário de cliente entra só no portal do cliente.',
    'usuarios.plataformas.entra': 'Entra',
    'usuarios.plataformas.naoEntra': 'Não entra',
    'usuarios.plataformas.motivoSuper': 'Por ser superusuário',
    'usuarios.plataformas.motivoCliente': 'O portal do cliente não é plataforma',
    'usuarios.plataformas.motivoCargo': 'Pelo cargo {{cargo}}: {{areas}}',
    'usuarios.plataformas.motivoAreas': 'Pelas áreas próprias: {{areas}}',
    'usuarios.plataformas.motivoSemArea': 'Nenhuma área desta plataforma',
  },
  en: {
    'declarative.Plataformas': 'Platforms',
    'usuarios.plataformas.superusuario': 'Superuser',
    'usuarios.plataformas.portal': 'Customer portal',
    'usuarios.plataformas.cliente': 'Customer',
    'usuarios.plataformas.nenhuma': 'None',
    'usuarios.plataformas.titulo': 'Platform access',
    'usuarios.plataformas.regraSuper': 'A superuser enters both platforms, with every area.',
    'usuarios.plataformas.regraOperador': 'The platform comes from the areas: the user enters where the position or their own areas grant at least one area.',
    'usuarios.plataformas.regraCliente': 'A customer user enters only the customer portal.',
    'usuarios.plataformas.entra': 'Enters',
    'usuarios.plataformas.naoEntra': 'No access',
    'usuarios.plataformas.motivoSuper': 'As a superuser',
    'usuarios.plataformas.motivoCliente': 'The customer portal is not a platform',
    'usuarios.plataformas.motivoCargo': 'Through the position {{cargo}}: {{areas}}',
    'usuarios.plataformas.motivoAreas': 'Through their own areas: {{areas}}',
    'usuarios.plataformas.motivoSemArea': 'No area of this platform',
  },
  es: {
    'declarative.Plataformas': 'Plataformas',
    'usuarios.plataformas.superusuario': 'Superusuario',
    'usuarios.plataformas.portal': 'Portal del cliente',
    'usuarios.plataformas.cliente': 'Cliente',
    'usuarios.plataformas.nenhuma': 'Ninguna',
    'usuarios.plataformas.titulo': 'Acceso a las plataformas',
    'usuarios.plataformas.regraSuper': 'El superusuario entra en las dos plataformas, con todas las áreas.',
    'usuarios.plataformas.regraOperador': 'La plataforma viene de las áreas: entra donde el cargo o las áreas propias dan al menos un área.',
    'usuarios.plataformas.regraCliente': 'El usuario de cliente entra solo en el portal del cliente.',
    'usuarios.plataformas.entra': 'Entra',
    'usuarios.plataformas.naoEntra': 'No entra',
    'usuarios.plataformas.motivoSuper': 'Por ser superusuario',
    'usuarios.plataformas.motivoCliente': 'El portal del cliente no es plataforma',
    'usuarios.plataformas.motivoCargo': 'Por el cargo {{cargo}}: {{areas}}',
    'usuarios.plataformas.motivoAreas': 'Por las áreas propias: {{areas}}',
    'usuarios.plataformas.motivoSemArea': 'Ninguna área de esta plataforma',
  },
}
